<script>
import { mapActions } from 'vuex'

export default {
  beforeDestroy () {
    this.hidePreview()
  },

  methods: {
    ...mapActions('modal', [
      'setModalFile',
      'hideModal'
    ]),
    thumbnailPlaceholder (type) {
      let placeholder = '/images/placeholder-'
      switch (type) {
        case 1:
          placeholder += 'audio.png'
          break
        case 2:
          placeholder += 'video.png'
          break
        case 3:
          placeholder += 'photo.png'
          break
        case 4:
          placeholder += 'archive.png'
          break
        case 5:
          placeholder += 'folder.png'
          break
        case 7:
          placeholder += 'voice.png'
          break
        default:
          placeholder += 'note.png'
          break
      }
      return placeholder
    },
    handleSelect (file) {
      switch (file.type) {
        case 5:
          this.$router.push({ path: `/files/${file.id}` })
          break
        case 1:
        case 2:
        case 3:
          this.showPreview(file)
          break
        default:
          break
      }
    },
    showPreview (file) {
      this.setModalFile({ modal: 'preview', file })
    },
    hidePreview () {
      this.hideModal('preview')
    }
  }
}
</script>
